// extracted by mini-css-extract-plugin
module.exports = {"injectionsWrapper":"injections_injectionsWrapper___Pa23"};